import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Box, Grid, Typography } from '@material-ui/core';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import useStyles from '../../Main.style';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import useCalendarEvents from '../../../../hooks/useCalendarEvents';

const CalendarDashboardView = () => {
  const [weekDatesofEvents, setWeekDatesofEvents] = useState({});
  const [notificationRole, setNotificationRole] = useState('');
  const { getCalendarEventsForWeek } = useCalendarEvents();
  const classes = useStyles();
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  const bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  let calendarEventsData = {};
  // State Declaration
  const navigate = useNavigate();
  const loadCalendarEventsForWeek = async () => {
    let weekDatesObj = {};

    if (Object.keys(calendarEventsData).length === 0) {
      calendarEventsData = await getCalendarEventsForWeek();
    }

    if (Object.keys(calendarEventsData).length > 0) {
      weekDatesObj = calendarEventsData?.usersResult?.reduce((result, current) => {
        const date = current.dateFrom;
        if (!result[date]) {
          result[date] = [];
        }
        result[date].push(current);
        return result;
      }, {});

      const sortedWeekDatesOfEvents = Object.entries(weekDatesObj ?? [])
        .sort(([a], [b]) => new Date(b) - new Date(a))
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

      setWeekDatesofEvents(sortedWeekDatesOfEvents);
    }
  };

  const notificationPermission = () => {
    if (loggedInUserData.roleId === 1) {
      setNotificationRole('Leadership');
    } else if (loggedInUserData.roleId === 0) {
      setNotificationRole('employees');
    } else if (loggedInUserData.roleId === 2) {
      setNotificationRole('alumni');
    }
  };
  useEffect(() => {
    loadCalendarEventsForWeek();
  }, []);

  useEffect(() => {
    notificationPermission();
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5">This Week's Events</Typography>
            <Box mt={0.5} />
          </Grid>

          {Object.keys(weekDatesofEvents).length > 0 ? (
            <>
              {Object.keys(weekDatesofEvents).map((day) => {
                return weekDatesofEvents[day].map((e, index) => {
                  const previousDay =
                    index > 0 ? weekDatesofEvents[day][index - 1].dateFrom.slice(0, 10) : null;
                  return (
                    <>
                      {previousDay !== e.dateFrom.slice(0, 10) && (
                        <Grid item xs={12}>
                          <Box className={classes.innercontentWhite}>
                            <Typography variant="h5" style={{ fontSize: '13px' }}>
                              {moment(day).isSame(moment(), 'day') && 'Today -'}{' '}
                              {moment(day).format('dddd, MMMM Do')}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                      <If condition={e?.receivers == notificationRole || e?.receivers == 'All'}>
                        <Grid item xs={12}>
                          <Box className={classes.innercontentWhite}>
                            <Box>
                              <Typography variant="h5">{e.name}</Typography>
                            </Box>
                            <Box>
                              <Typography variant="body2">{e.description}</Typography>
                            </Box>
                          </Box>
                        </Grid>
                      </If>
                    </>
                  );
                });
              })}
            </>
          ) : (
            <Grid item xs={12}>
              <Box className={classes.innercontentWhite}>
                <Box>
                  <Typography variant="body2">No events this week</Typography>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end" alignItems="flex-end" height={1} mt={0.5}>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Box>
              <a
                color="textPrimary"
                href="javascript:;"
                onClick={() => {
                  navigate('/app/calendarnotification');
                }}
              >
                <Typography variant="caption">View all</Typography>
              </a>
            </Box>
            <Box className={classes.ViewAll}>
              <ArrowForwardIcon />
            </Box>
          </Box>
        </Box>
      </Grid>
    </>
  );
};
export default CalendarDashboardView;
